<template>
  <div v-if="primary_tag" class="tags-container">
    <div v-if="primary_tag.name" class="dominant">
      <mention-individual tagClass="organization" :showScoringSystem="showScoringSystem" :mention="primary_tag"></mention-individual>
    </div>
    <div v-if="showScoringSystem && primary_tag.total_score" class="dominant score-wrapper">
      <span class="tag sentiment">{{primary_tag.total_score || 0}}</span>
    </div>
    <div v-if="primary_tag.organizations && primary_tag.organizations.length > 0">
      <h5 for>{{$t("articles.mentions.labels.organizations")}}</h5>
      <div>
        <mention-individual tagClass="organization" :showScoringSystem="showScoringSystem" :mention="organization" :key="index" v-for="(organization, index) in primary_tag.organizations">
          <span
            v-if="allowDelete"
            v-on:click="(e) => deleteMentionTag({type: 'organization',tag:organization})"
            class="fas fa-times fa-plus"
          ></span>
        </mention-individual>
      </div>
    </div>
    <div v-if="tags && tags.length > 0">
      <h5 for>{{$t("articles.mentions.labels.tags")}}</h5>
      <div>
        <mention-individual :showScoringSystem="showScoringSystem" :mention="tag" :key="index" v-for="(tag, index) in tags">
          <span
            v-if="allowDelete"
            v-on:click="(e) => deleteMentionTag({type: 'tag', tag})"
            class="fas fa-times fa-plus"
          ></span>
        </mention-individual>
      </div>
    </div>
    <div v-if="primary_tag.sources && primary_tag.sources.length > 0">
      <h5 for>{{$t("articles.mentions.labels.sources")}}</h5>
      <div>
        <mention-individual tagClass="sources" :showScoringSystem="showScoringSystem" :mention="source" :key="index" v-for="(source, index) in primary_tag.sources">
          <span
            v-if="allowDelete"
            v-on:click="(e) => deleteMentionTag({type:'source', tag: source})"
            class="fas fa-times fa-plus"
          ></span>
        </mention-individual>
      </div>
    </div>
  </div>
</template>

<script>
import MentionIndividual from "../../components/coding-admin/mention-individual";

import {CATEGORY_TYPES} from "../../config/const";

export default {
  name: "mention",
  props: {
    primary_tag: Object,
    allowDelete: Boolean,
    OnDeleteMentionTag: Function,
    showScoringSystem: {
      type: Boolean,
      default: false
    },
    showSharedMentions: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tags () {
      let primaryTag = this.primary_tag;
      let tags = primaryTag.tags;

      if (!this.showSharedMentions) {
        tags = tags.filter(tag => tag.category_type_id !== CATEGORY_TYPES.ORGANIZATION);
        if(primaryTag.organization_id) {
          tags = tags.filter(tag => [CATEGORY_TYPES.GROUPING, CATEGORY_TYPES.ARTICLE_FEATURE].indexOf(tag.category_type_id) === -1)
        }
        else {
          tags = tags.filter(
            (tag) =>
              tag.category_type_id === CATEGORY_TYPES.ARTICLE_FEATURE ||
              tag.category_type_id === CATEGORY_TYPES.MEDIA_TAG
          );
        }
      }

      return tags
    }
  },
  methods: {
    deleteMentionTag(mention) {
      this.OnDeleteMentionTag(mention);
    }
  },
  components: {
    MentionIndividual
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/components/coding-admin/tags.scss";
.headline {
  border-bottom: 2px solid #ddd;
  font-weight: 700;
  text-transform: uppercase;
  padding-bottom: 5px;
  padding-left: 10px;
  color: #b0b6b8;
  margin-top: 20px;
}
h4 {
  @extend .headline;
  font-size: 14px;
}
h5 {
  // @extend .headline;
  line-height: 14px;
  margin-bottom: 2px;
  margin-top: 6px;
  font-size: 11px;
}
.dominant {
  height: 0px;
  position: relative;
  top: -30px;
}
</style>